import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NewRelicEventsService } from '@services/new-relic-events.service';
import { NEW_RELIC_EVENT } from '@enums/new-relic.enum';

export type ExperienceRating = 'bad' | 'good' | 'excellent';

@Component({
  selector: 'app-am-experience-poll',
  templateUrl: './am-experience-poll.component.html',
  styleUrls: ['./am-experience-poll.component.scss'],
  standalone: false,
})
export class AmExperiencePollComponent {
  /**
   * reservationCode pre-capturado por el modal padre para garantizar
   * que el dato esté disponible al momento de enviar la métrica.
   */
  @Input() reservationCode = '';

  @Output() ratingSelected = new EventEmitter<ExperienceRating>();

  selectedRating: ExperienceRating | null = null;

  readonly options: { value: ExperienceRating; emoji: string; labelKey: string }[] = [
    { value: 'bad', emoji: '😡', labelKey: 'experiencePoll.bad' },
    { value: 'good', emoji: '😌', labelKey: 'experiencePoll.good' },
    { value: 'excellent', emoji: '😊', labelKey: 'experiencePoll.excellent' },
  ];

  constructor(private _newRelicEventsService: NewRelicEventsService) {}

  onSelect(rating: ExperienceRating): void {
    this.selectedRating = rating;
    this.ratingSelected.emit(rating);

    this._newRelicEventsService.trackEvent(NEW_RELIC_EVENT.EXPERIENCE_POLL_RESPONSE, {
      rating,
      reservationCode: this.reservationCode,
    });
  }
}
